export function formatPercentage(value) {
  return Number.isInteger(value) ? `${value}` : `${value.toFixed(1)}`
}
